import React, { Component, Fragment } from 'react';
import {
    Button,
    translate,
    crudDelete,
} from 'react-admin';
import { startUndoable as startUndoableAction } from 'ra-core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '../../icon/IcnDelete';
import SimpleButton from '@material-ui/core/Button';

const styles = {
    button: { marginRight: '1em', marginLeft: '1em' },
};

class RuleDeleteButton extends Component {
    state = {
        showDialog: false
    };

    handleClick = () => {
        this.setState({ showDialog: true });
    }

    handleCloseClick = () => {
        this.setState({ showDialog: false });
    };

    handleSubmit = () => {
        const { record, startUndoable, basePath, resource } = this.props;
        startUndoable(crudDelete(resource, record.id, record, basePath));
        this.setState({ showDialog: false });
    }

    render() {
        const { showDialog } = this.state;
        const { translate } = this.props;
        return (
            <Fragment>
                <Button
                    size="small"
                    color="secondary"
                    label='ra.action.delete'
                    onClick={this.handleClick}>
                    <DeleteIcon />
                </Button>
                <Dialog
                    fullWidth
                    open={showDialog}
                    onClose={this.handleCloseClick}
                >
                    <DialogContent>
                        <DialogContentText>
                            <p>
                                {translate('resources.operation-rules.fields.deleteGuidance')}
                            </p>

                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <SimpleButton
                            variant='raised'
                            onClick={this.handleSubmit}
                            color='primary'>
                            {translate('ra.action.delete')}
                        </SimpleButton>
                        <SimpleButton
                            onClick={this.handleCloseClick}
                            color='primary'>
                            {translate('ra.action.cancel')}
                        </SimpleButton>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}

const enhance = compose(
    translate,
    connect(
        undefined,
        { crudDelete, startUndoable: startUndoableAction }
    ),
    withStyles(styles)
);

export default enhance(RuleDeleteButton);